module.exports = __webpack_public_path__ + "static/media/Banner-SavonDog.e6fe56ea.jpg";